const ASSET_FILTER_TYPES = {
    ALL: "ALL",
    ALLOCATED: "ALLOCATED",
    NOT_ALLOCATED: "NOT_ALLOCATED",
}

export { ASSET_FILTER_TYPES }
